import React, { useEffect, useState } from "react";
import "../styles/TimerDate.css";

const game1 = [
  { d: "MONDAY SPECIAL", day: "Monday", closingTime: "19:55" },
  { d: "LUCKY TUESDAY", day: "Tuesday", closingTime: "19:55" },
  { d: "MIDWEEK", day: "Wednesday", closingTime: "19:55" },
  { d: "FORTUNE THURSDAY", day: "Thursday", closingTime: "19:55" },
  { d: "FRIDAY BONANZA", day: "Friday", closingTime: "19:55" },
  { d: "NATIONAL WEEKLY", day: "Saturday", closingTime: "19:55" },
  { d: "SUNDAY ASEDA", day: "Sunday", closingTime: "17:55" },
];

const game2 = [
  { d: "NLA VAG MONDAY", day: "Monday", closingTime: "09:50" },
  { d: "NLA NOON RUSH MONDAY", day: "Monday", closingTime: "13:25" },
     { d: "HUNTEX MONDAY", day: "Monday", closingTime: "21:50" },
  { d: "NLA VAG TUESDAY", day: "Tuesday", closingTime: "09:50" },
  { d: "NLA NOON RUSH TUESDAY", day: "Tuesday", closingTime: "13:25" },
     { d: "HUNTEX AKOMA TUESDAY", day: "Tuesday", closingTime: "21:50" },
  { d: "NLA VAG WEDNESDAY", day: "Wednesday", closingTime: "09:50" },
  { d: "NLA NOON RUSH WEDNESDAY", day: "Wednesday", closingTime: "13:25" },
     { d: "HUNTEX WEDNESDAY", day: "Wednesday", closingTime: "21:50" },
  { d: "NLA VAG THURSDAY", day: "Thursday", closingTime: "09:50" },
  { d: "NLA NOON RUSH THURSDAY", day: "Thursday", closingTime: "13:25" },
    { d: "HUNTEX THURSDAY", day: "Thursday", closingTime: "21:50" },
  { d: "NLA VAG FRIDAY", day: "Friday", closingTime: "09:50" },
  { d: "NLA NOON RUSH FRIDAY", day: "Friday", closingTime: "13:25" },
      { d: "HUNTEX FRIDAY", day: "Friday", closingTime: "21:50" },
  { d: "NLA VAG SATURDAY", day: "Saturday", closingTime: "09:50" },
  { d: "NLA NOON RUSH SATURDAY", day: "Saturday", closingTime: "13:25" },
     { d: "HUNTEX SATURDAY", day: "Saturday", closingTime: "21:50" },
     { d: "HUNTEX SUNDAY", day: "Sunday", closingTime: "21:50" },
];

function getTimeRemaining(game) {
  const now = new Date();

  if (!Array.isArray(game)) {
    return [];
  }

  const validGames = game.filter((gameItem) => {
    if (!gameItem || typeof gameItem !== "object") return false;
    if (typeof gameItem.day !== "string" || typeof gameItem.closingTime !== "string") return false;
    return /^\d{1,2}:\d{2}$/.test(gameItem.closingTime);
  });

  const remainingTimes = validGames.map((gameItem) => {
    const gameDayIndex = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ].indexOf(gameItem.day);
    const currentDayIndex = now.getDay();

    let nextGameDayIndex = (gameDayIndex - currentDayIndex + 7) % 7;

    const nextGameDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + nextGameDayIndex
    );

    const closingTimeParts = gameItem.closingTime.split(":");
    const closingTime = new Date(
      nextGameDate.getFullYear(),
      nextGameDate.getMonth(),
      nextGameDate.getDate(),
      parseInt(closingTimeParts[0]),
      parseInt(closingTimeParts[1])
    );

    if (closingTime < now) {
      closingTime.setDate(closingTime.getDate() + 7);
      nextGameDate.setDate(nextGameDate.getDate() + 7);
    }

    const timeDifference = closingTime - now;
    const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    const hours = Math.floor(
      (timeDifference % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    );
    const minutes = Math.floor(
      (timeDifference % (60 * 60 * 1000)) / (60 * 1000)
    );
    const seconds = Math.floor((timeDifference % (60 * 1000)) / 1000);

    return {
      d: gameItem.d,
      day: gameItem.day,
      closingTime: closingTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      }),
      nextGameDate: nextGameDate.toLocaleDateString("en-US"),
      remainingTime: {
        days,
        hours,
        minutes,
        seconds,
      },
      nextGameStartTime: closingTime.toISOString(),
    };
  });

  const sortedGames = remainingTimes.sort((a, b) => {
    const daysDiff = a.remainingTime.days - b.remainingTime.days;
    if (daysDiff !== 0) {
      return daysDiff;
    }

    const timeA = parseInt(a.closingTime.replace(":", ""));
    const timeB = parseInt(b.closingTime.replace(":", ""));
    return timeA - timeB;
  });

  return sortedGames;
}

const TimerDate = ({ selectedGame }) => {
  if (!selectedGame) return null;

  return (
    <div className="timer-card">
      <div className="game-date">
        <h2 className="game-title">{selectedGame.d}</h2>
        <div className="heading">Congratulations, you are on a roll!</div>
        <div className="heading">
          Don't miss out. Play the next lottery draw now!
        </div>
        <div className="time-container">
          <div className="timeBox">
            <div className="title1">{selectedGame.remainingTime.days}</div>
            <div className="title1">Days</div>
          </div>
          <div className="timeBox">
            <div className="title1">{selectedGame.remainingTime.hours}</div>
            <div className="title1">Hrs</div>
          </div>
          <div className="timeBox">
            <div className="title1">{selectedGame.remainingTime.minutes}</div>
            <div className="title1">Mins</div>
          </div>
          <div className="timeBox">
            <div className="title1">{selectedGame.remainingTime.seconds}</div>
            <div className="title1">Sec</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimerDate;
